export default __webpack_public_path__ + "static/media/k_wdt_c_4.d0d0356b.mp3";